import React, { useState, useMemo, useEffect } from 'react';
import moment from 'moment';
import { Divider, Card, Row, Col, DatePicker, message } from 'antd';
import DF from 'DisplayFramework';
import {
  CreateSInvoiceFileParams,
  createSInvoiceFile,
} from '../../../services/supplierInvoice';
import JobResult from '../../Accounting/Components/JobResult';
import { useQuery } from 'react-query';
import FormInput from 'components/FormInput';
import { Form } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { dateToString, shouldUpdateCompare } from 'utils/utils2';
import Button from 'components/Button';
import Title from 'components/Title';

import ThirdPartyInput from 'components/ThirdPartyInput';
import MGListByUser from 'components/MgListByUser';
import ParListSelect from 'components/ParListSelect';
import { getMgParValueByParCode } from 'services/parametersService';
import Value from 'components/Value';
import ServiceList from 'components/ServiceList';

const initialSearchParams: CreateSInvoiceFileParams = {
  tpidsupplier: 0,
  ctetype: 'SERVIN',
  ctedirection: 'IN',
  servcode: '',
  cipaystatus: '',
  startdate: moment() as any,
  enddate: moment() as any,
  currcode: '',
  mgid: Number(localStorage.getItem('mgid')),
};

const CreateSInvoiceFileService = () => {
  const [form] = useForm();
  const [searchParams, setSearchParams] =
    useState<CreateSInvoiceFileParams>(initialSearchParams);

  const loadSFCiPayStatus = async () => {
    await getMgParValueByParCode({
      parcode: 'SFPAYSTAT',
    })
      .then((response) => {
        if (response.data != null) {
          form.setFieldsValue({
            cipaystatus: response.data.parvaluemin ?? 'PAID',
          });
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    loadSFCiPayStatus();
  });

  const onFinish = (values: CreateSInvoiceFileParams) => {
    setSearchParams((prev) => ({
      ...prev,
      ...values,
    }));
    setTimeout(refetch, 0);
  };

  const params = useMemo(
    () => ({
      ...searchParams,
      tpidsupplier: form.getFieldValue('tpidsupplier') ?? 0,
      targetPayStatus: form.getFieldValue('ciPayStatus') ?? 'PAID',
      currcode: form.getFieldValue('currcode'),
      ctetype: form.getFieldValue('ctetype'),
      ctedirection: form.getFieldValue('ctedirection'),
      servcode: form.getFieldValue('servcode'),
      startdate: dateToString(searchParams.startdate),
      enddate: dateToString(searchParams.enddate),
      cipaystatus: form.getFieldValue('cipaystatus'),
    }),
    [form, searchParams]
  );

  const {
    data: jobResponse,
    refetch,
    isFetching,
  } = useQuery(
    ['createSInvoiceFile', params],
    () =>
      createSInvoiceFile(params).then((res) => {
        message.success({
          content: res.message,
          style: {
            marginTop: '20vh',
          },
        });
        return res;
      }),
    {
      enabled: false,
    }
  );

  return (
    <DF.Provider pagcode="createsifile">
      <Card
        title={<Title level={4} comcode="CreateSInvoiceFile"></Title>}
        size="small"
      >
        <Form
          form={form}
          onFinish={onFinish}
          initialValues={initialSearchParams}
        >
          <br></br>
          <Row gutter={[8, 8]}>
            <FormInput col xs={24} md={8} lg={6} name="mgid">
              <MGListByUser userid={Number(localStorage.getItem('userid'))} />
            </FormInput>
            <FormInput col xs={24} md={8} lg={6} name="currcode">
              <ParListSelect parcode="CURRENCY" />
            </FormInput>
            <FormInput col xs={24} md={8} lg={6} name="cipaystatus">
              <Value />
            </FormInput>

            <FormInput col xs={24} md={8} lg={6} name="tpidsupplier">
              <ThirdPartyInput role="SUPPLIER" onlytpid />
            </FormInput>
            <FormInput col xs={24} md={8} lg={6} name="ctetype">
              <ParListSelect parcode="CTETYPESI" />
            </FormInput>

            <Form.Item
              shouldUpdate={shouldUpdateCompare('tpidsupplier')}
              noStyle
            >
              {({ getFieldValue }) => {
                return (
                  <FormInput col xs={24} md={8} lg={6} name="servcode">
                    <ServiceList tpidsupplier={getFieldValue('tpidsupplier')} />
                  </FormInput>
                );
              }}
            </Form.Item>

            <FormInput col xs={24} md={8} lg={6} name="startdate">
              <DatePicker showToday />
            </FormInput>
            <FormInput col xs={24} md={8} lg={6} name="enddate">
              <DatePicker showToday />
            </FormInput>
          </Row>
          <Row justify="end">
            <Col xs={24} md={8} lg={6}>
              <Button
                loading={isFetching}
                comcode="runservice"
                type="primary"
                htmlType="submit"
              />
            </Col>
          </Row>
          <Row>
            <Col style={{ alignContent: 'center' }} xs={24}>
              {isFetching && (
                <Title level={3} type="danger" comcode="pleasewait" />
              )}
            </Col>
          </Row>
        </Form>
        <Divider></Divider>
        <br />
        <br />

        <JobResult jobResponse={jobResponse} entity="SINVOICE" />
      </Card>
    </DF.Provider>
  );
};

export default CreateSInvoiceFileService;
